import { render } from "./ComponentDetailSubCategory.vue?vue&type=template&id=8b2abc0a&scoped=true"
import script from "./ComponentDetailSubCategory.vue?vue&type=script&lang=js"
export * from "./ComponentDetailSubCategory.vue?vue&type=script&lang=js"

import "./ComponentDetailSubCategory.vue?vue&type=style&index=0&id=8b2abc0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b2abc0a"]])

export default __exports__